/**
 * CTA Grid — Results Category Filter + Modal
 *
 * Handles filtering result cards by category using pill buttons
 * and a mobile dropdown select. Opens a shared modal for full descriptions.
 */
document.addEventListener('DOMContentLoaded', () => {
	const grids = document.querySelectorAll('.cta-grid--results');

	grids.forEach((grid) => {
		const filterBtns = grid.querySelectorAll('.cta-grid__filter-btn');
		const filterDropdown = grid.querySelector('.cta-grid__filter-dropdown select');
		const items = grid.querySelectorAll('.cta-grid__result-item');
		const modal = grid.querySelector('.cta-grid__modal');

		if (!items.length) return;

		/**
		 * Filter items by category slug
		 * @param {string} category - Category slug or 'all'
		 */
		const filterItems = (category) => {
			items.forEach((item) => {
				item.classList.add('is-fading');
			});

			setTimeout(() => {
				items.forEach((item) => {
					const itemCat = item.getAttribute('data-category');
					const shouldShow = category === 'all' || itemCat === category;

					if (shouldShow) {
						item.classList.remove('is-hidden');
					} else {
						item.classList.add('is-hidden');
					}
				});

				requestAnimationFrame(() => {
					items.forEach((item) => {
						if (!item.classList.contains('is-hidden')) {
							item.classList.remove('is-fading');
						}
					});
				});
			}, 300);
		};

		// Pill button click handlers
		filterBtns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				const category = btn.getAttribute('data-filter');

				filterBtns.forEach((b) => b.classList.remove('active'));
				btn.classList.add('active');

				if (filterDropdown) {
					filterDropdown.value = category;
				}

				filterItems(category);
			});
		});

		// Mobile dropdown change handler
		if (filterDropdown) {
			filterDropdown.addEventListener('change', () => {
				const category = filterDropdown.value;

				filterBtns.forEach((b) => {
					b.classList.toggle('active', b.getAttribute('data-filter') === category);
				});

				filterItems(category);
			});
		}

		// Modal functionality
		if (!modal) return;

		const modalCategory = modal.querySelector('.cta-grid__modal-category');
		const modalAmount = modal.querySelector('.cta-grid__modal-amount');
		const modalDescription = modal.querySelector('.cta-grid__modal-description');

		const openModal = (card) => {
			const category = card.dataset.resultCategory || '';
			const amount = card.dataset.resultAmount || '';
			const description = card.dataset.resultDescription || '';

			modalCategory.textContent = category;
			modalCategory.style.display = category ? '' : 'none';
			modalAmount.textContent = amount;
			modalDescription.innerHTML = description;

			modal.classList.add('is-active');
			modal.setAttribute('aria-hidden', 'false');
			document.body.style.overflow = 'hidden';
		};

		const closeModal = () => {
			modal.classList.remove('is-active');
			modal.setAttribute('aria-hidden', 'true');
			document.body.style.overflow = '';
		};

		// Open modal on tile click
		grid.querySelectorAll('.cta-grid__result-card').forEach((card) => {
			card.addEventListener('click', () => {
				if (card.dataset.resultDescription) {
					openModal(card);
				}
			});
		});

		// Close on X button
		modal.querySelector('.cta-grid__modal-close').addEventListener('click', closeModal);

		// Close on overlay click
		modal.addEventListener('click', (e) => {
			if (e.target === modal) {
				closeModal();
			}
		});

		// Close on Escape key
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && modal.classList.contains('is-active')) {
				closeModal();
			}
		});
	});
});
